import { Oval } from "react-loader-spinner";

const Loader = ({ visible }) => {
  return (
    <Oval
      height={60}
      width={60}
      color="#cc0634ff"
      visible={visible}
      ariaLabel="oval-loading"
      secondaryColor="#980f51ff"
      strokeWidth={2}
      strokeWidthSecondary={2}
    />
  );
};

export default Loader;
